import { makeStyles, Theme, createStyles } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        sectionTitle: {
            ...commonStyles.sectionTitle,
            marginBottom: 20,
            marginTop: 20,
        },
        chipContainer: {
            maxWidth: '33%',
            width: '100%',
        },
        chip: {
            maxWidth: '100%',
            width: '100%',
            '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
            },
        },
        chipGrid: {
            maxWidth: '100%',
            overflow: 'hidden',
        },
    })
);
